// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__7_iaM","title":"AfterBackImages_title__1i8GC","images":"AfterBackImages_images__1yu_n"};